// Route guard. Redirects to /login if there is no active session, preserving
// the attempted path in `?next=` so we can return after sign-in.

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.js';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  // Still hydrating from sessionStorage — render nothing rather than flash
  // the login screen.
  if (status.kind === 'idle') return null;

  if (status.kind !== 'authenticated') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
